// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero-div[data-v-b95e0270]{bottom:0;height:4rem;width:86.5%;background:#8aaef0}.hero-div.animation[data-v-b95e0270]{-webkit-animation:ease-in-out;-webkit-animation-name:w-b95e0270;-webkit-animation-duration:5s}.hero-image[data-v-b95e0270] img{width:100%}@media (min-width:1024px){.hero-div[data-v-b95e0270]{height:8rem}.hero-box[data-v-b95e0270]{right:-5.8125rem;top:-5.625rem}}@keyframes w-b95e0270{0%{width:0}to{width:86.5%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
